import { schema } from "normalizr";
import { PermissionArraySchema } from "./permission";

const PermissionChildrenSchema = new schema.Entity("permissionChildren", {
  permissions: PermissionArraySchema,
});
const PermissionChildrenArraySchema = new schema.Array(PermissionChildrenSchema);

export { PermissionChildrenSchema, PermissionChildrenArraySchema };